module.exports = __webpack_public_path__ + "img/ab8496c.png";